import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory, useParams } from 'react-router-dom';
import {
  Alert,
  Form,
  Table,
  Modal,
  Dropdown,
  DropdownButton
} from 'react-bootstrap';
import _get from 'lodash/get';
import _size from 'lodash/size';
import _isEmpty from 'lodash/isEmpty';
import Accordion from '@material-ui/core/Accordion';
import { Tab, Tabs, TabPanel, TabList } from 'react-tabs';
import TextField from '@material-ui/core/TextField';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@material-ui/core';
import ReactPlayer from 'react-player';
import FormGroup from '@material-ui/core/FormGroup';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import { purple, red } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { Favorite, Share, ExpandMore, MoreVert } from '@material-ui/icons';
// import ShareIcon from '@material-ui/icons/Share';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import FavoriteIcon from '@material-ui/icons/FavoriteIcon';
// import MoreVertIcon from '@material-ui/icons/MoreVert';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Container, Wrapper, HomeButtons } from '../../styles/HomeStyles';
import Header from '../header/Header';
import { FormWrapper, Label } from '../../styles/LoginStyles';
import Dimage from '../../assets/3D-printing.jpg';
// import { TabPanel, a11yProps } from '../instructor/Home';
import {
  DashboardWrapper,
  ButtonWrapper,
  ContentWrapper,
  TextWrapper,
  ControlButtonWrapper,
  ActionButtons,
  UserLabel,
  TableWrapper,
  NormalText
} from '../../styles/DashboardStyles';
import { SwitchButton, InputWrapper, Row } from '../../styles/InstructorStyles';
import { config } from '../../config';
import { styles } from '../../styles/TabStyles';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  tabTextColor: {
    backgroundColor: '#4287cc'
  },
  media: {
    height: 0,
    paddingTop: '56.25%' // 16:9
  },
  form: {
    '& .MuiTextField-root': {
      margin: theme.spacing(10),
      width: '25ch'
    }
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  avatar: {
    backgroundColor: red[500]
  }
}));

export default function VideoPage(props1) {
  console.log(props1, 'props');
  const { name } = useParams();
  console.log(name, 'name');
  const history = useHistory();

  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(false);
  const [tabValue, setValue] = useState(0);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleValueChange = (event, newValue) => {
    setValue(newValue);
  };

  const [approvedAdmins, setApprovedAdmins] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentCategories, setCurrentCategories] = useState([]);
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [currentLectures, setCurrentLectures] = useState([]);

  const [category, setCategory] = useState(null);
  const [course, setCourse] = useState(null);
  const [section, setSection] = useState(null);
  const [video, setVideo] = useState(null);
  const [lectureName, setLecture] = useState('');
  const [lectureLink, setLectureLink] = useState('');
  const [lectureDescription, setLectureDescription] = useState('');

  const [supportDescription, setSupportDescription] = useState('');
  const [supportEmail, setSupportEmail] = useState('');
  const [supportName, setSupportName] = useState('');

  const [categoryInput, setCategoryInput] = useState('');
  const [courseInput, setCourseInput] = useState('');
  const [sectionInput, setSectionInput] = useState('');

  const [categoryid, setCategoryId] = useState(null);
  const [courseid, setCourseId] = useState(null);
  const [sectionid, setSectionId] = useState(null);

  const [addNew, setAddNew] = useState(false);
  const [status, setStatus] = useState(false);
  const [videoModalShow, setVideoModalShow] = useState(false);
  const [successModalShow, setSuccessModalShow] = useState(false);
  const [displayLectures, setDisplayLectures] = useState(true);

  const showLectures = () => {
    setDisplayLectures(true);
  };

  const showStats = () => {
    setDisplayLectures(false);
  };

  const showVideo = index => {
    setVideo(index);
    setVideoModalShow(true);
  };

  const SuccessModal = props => {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Success!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{status}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <Container>
      <DashboardWrapper>
        <Header />
      </DashboardWrapper>
      <ContentWrapper></ContentWrapper>
    </Container>
  );
}
